import React from 'react'
import { useNavigate } from 'react-router-dom'
import './Main.css'
const Header = () => {
    const navigate = useNavigate()
  return (
    <div className="header">
        <div className="padding">
        <h2>Asian <b>Student</b> Union</h2>
        </div>
        <div className="padding2">
           <button onClick={() => {
             navigate('/announcements')
           }}><b>Announcements</b></button>
        </div>
    </div>
  )
}

export default Header